import {
    faCheckCircle,
    faCircleInfo,
    faExclamationTriangle
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const iconMap = {
    success: faCheckCircle,
    info: faCircleInfo,
    'info-muted': faCircleInfo,
    warning: faExclamationTriangle,
    danger: faExclamationTriangle
};

const InfoBox = ({ variant = 'info-muted', className, children }) => {
    const icon = iconMap[variant] || null;
    return (
        <div className={`info-box info-box--${variant} ${className || ''}`.trim()}>
            {icon && (
                <FontAwesomeIcon
                    icon={icon}
                    className={`info-box__icon info-box__icon--${variant}`}
                />
            )}
            <div className="info-box__content">{children}</div>
        </div>
    );
};

export default InfoBox;
